var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.href ? "a" : "button",
    _vm._b(
      {
        tag: "component",
        staticClass: "flex items-center rounded-md",
        class: { "px-4 py-2": !_vm.noPadding },
        on: {
          click: function($event) {
            !_vm.href && _vm.$emit("click", $event)
          }
        }
      },
      "component",
      _vm.href
        ? {
            href: _vm.href,
            target: "_blank"
          }
        : { type: _vm.submit ? "submit" : "button" },
      false
    ),
    [
      _vm.icon
        ? _c("BaseIcon", {
            class: _vm.computedIconClass,
            attrs: { name: _vm.icon }
          })
        : _vm._e(),
      _c("span", { class: _vm.textClass }, [_vm._t("default")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }